import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../../public/fonts/averta-light-webfont.woff2%22,%22weight%22:%22300%22,%22style%22:%22normal%22,%22variable%22:%22--font-averta-regular-light%22,%22preload%22:false}],%22variableName%22:%22avertaRegularLight%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'avertaRegularLight', 'avertaRegularLight Fallback'",
        fontWeight: 300,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
